export default __webpack_public_path__ + "static/media/completedServices.8b5b686c.svg";